import { getAccessToken } from './access-token'
import { isExpired, isExpiringSoon, refreshAccessToken } from './refresh-token'

export { decodeTokenPayload, clearTokens, setTokens, type TokenPayload, type AuthTokenPair } from './access-token'

/**
 * 取一个「可用」的 access token：
 * - 当前 token 仍有充足寿命 → 直接返回；
 * - 已过期/即将过期 → 刷新后返回新 token；
 * - 刷新失败但当前 token 尚未真正过期 → 退回它撑过本次请求；
 * - 否则返回 null（无有效令牌）。
 */
export const getValidAccessToken = async (): Promise<string | null> => {
  const current = getAccessToken()
  if (current && !isExpiringSoon(current)) return current

  const refreshed = await refreshAccessToken()
  if (refreshed) return refreshed

  if (current && !isExpired(current)) return current
  return null
}
